import $ from 'jquery';
import decounterPictoSettings from "@/utils/responsive/DecounterPictoSettings";
import Utils from "@/libs/Utils";

export const hasTimerInPictoFalshSale = (selector) => {
    return $(selector).attr('data-time');
}
export const setTimerForFlashSale = () => {
    if (hasTimerInPictoFalshSale("#clockdiv")) {
        const dateTimer = Utils.hasTimerInPictoFalshSale("#clockdiv")
        if (dateTimer) {
            const dateTimeSplited = dateTimer.split(" ");
            const dateSplited = dateTimeSplited[0].split("-");
            const timeSplited = dateTimeSplited[1].split(":");
            const deadline = new Date(Number(dateSplited[0]), Number(dateSplited[1]) - 1, Number(dateSplited[2]), Number(timeSplited[0]), Number(timeSplited[1]), Number(timeSplited[2]));// gestion du d�lais jours * heures * minutes * secondes
            decounterPictoSettings.initializeClock('clockdiv', deadline);
        }
    }
}
